// extracted by mini-css-extract-plugin
export var menuIcon = "_s2-0";
export var menuIconInline = "_s2-1";